import { LegalLayout, H2, P, UL } from "@/components/LegalLayout";

export default function Accessibility() {
  return (
    <LegalLayout title="Accesibilidad" updated="2026" testid="page-accesibilidad">
      <P>En CYVRLABS trabajamos para que <b>cyvrlabs.com</b> sea accesible para el mayor número posible de personas, tomando como referencia las Pautas de Accesibilidad para el Contenido Web (WCAG 2.1, nivel AA) y el estándar europeo EN 301 549.</P>

      <H2>1. Compromiso</H2>
      <P>Nos comprometemos a revisar y mejorar de forma continua la accesibilidad del sitio, aplicando buenas prácticas de diseño inclusivo en nuevos desarrollos y contenidos.</P>

      <H2>2. Medidas aplicadas</H2>
      <UL>
        <li>Estructura semántica con encabezados jerárquicos y textos alternativos en imágenes relevantes.</li>
        <li>Contraste de color cuidado sobre fondo oscuro para facilitar la lectura.</li>
        <li>Navegación por teclado y elementos interactivos identificables.</li>
        <li>Diseño adaptable (responsive) a distintos tamaños de pantalla y dispositivos.</li>
        <li>Idioma del sitio declarado (es) para lectores de pantalla.</li>
      </UL>

      <H2>3. Limitaciones conocidas</H2>
      <P>Algunos contenidos con animaciones o mapas interactivos pueden presentar limitaciones para determinadas tecnologías de asistencia. Trabajamos para ofrecer alternativas accesibles cuando sea necesario.</P>

      <H2>4. Contacto y sugerencias</H2>
      <P>Si encuentras dificultades para acceder a algún contenido o quieres proponer mejoras de accesibilidad, escríbenos a contacto@cyvrlabs.com. Atenderemos tu solicitud en el menor plazo posible.</P>
    </LegalLayout>
  );
}
